import * as React from "react";
import ControlLabel from "components/bootstrap/ControlLabel";
const BigLabel = ({ children = void 0, htmlFor }) => /* @__PURE__ */ React.createElement("h4", null, /* @__PURE__ */ React.createElement(ControlLabel, { htmlFor }, children));
export default BigLabel;
